import Footerr from "../components/Footerr/Footerr";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";

const sections = [
  {
    title: "1. Use of This Website",
    body: "This website is provided for general information about Terces Solutions and its consulting services. By using the site you agree to use it only for lawful purposes and in a way that does not infringe the rights of others.",
  },
  {
    title: "2. No Professional Advice",
    body: "Content on this site — including articles, tools, calculators, and case studies — is provided for general information only and does not constitute professional, financial, or legal advice for your specific situation. Engagement terms for consulting services are agreed separately in writing.",
  },
  {
    title: "3. Intellectual Property",
    body: "All content on this site, including text, graphics, logos, frameworks, and downloadable resources, is the property of Terces Solutions unless otherwise stated, and may not be reproduced or redistributed for commercial purposes without written permission.",
  },
  {
    title: "4. Case Studies & Results",
    body: "Results described in case studies and testimonials reflect specific engagements. Outcomes vary by business, and past results do not guarantee future performance.",
  },
  {
    title: "5. Third-Party Links",
    body: "This site may link to third-party websites and services. We are not responsible for the content or privacy practices of those sites.",
  },
  {
    title: "6. Limitation of Liability",
    body: "To the maximum extent permitted by law, Terces Solutions is not liable for any indirect or consequential loss arising from use of this website or reliance on its content.",
  },
  {
    title: "7. Changes",
    body: "We may update these terms from time to time. Continued use of the site after changes constitutes acceptance of the updated terms.",
  },
  {
    title: "8. Contact",
    body: "Questions about these terms? Email us at info@terces.io.",
  },
];

function TermsPage() {
  usePageMeta({
    title: "Terms of Service | Terces Solutions",
    description:
      "Terms governing the use of the Terces Solutions website and its content.",
    path: "/terms",
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-6 pt-32 pb-20">
        <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
          Terms of Service
        </h1>
        <p className="text-sm text-gray-500 mb-10">Last updated: July 2026</p>
        {sections.map((s) => (
          <section key={s.title} className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-2">{s.title}</h2>
            <p className="text-gray-700 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </main>
      <Footerr />
    </div>
  );
}

export default TermsPage;
